<template>
  <!-- 未绑定的ICCID下拉选择 -->
  <el-select
    v-model="selected"
    clearable
    filterable
    :placeholder="placeholder"
    :remote="true"
    :remote-method="getModelList"
    :disabled="disabled"
    :loading="remoteLoading"
  >
    <el-option
      v-for="item in modelList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>
<script>
import { getUnBoundIccid } from '@/api/baseInfo/index.js';

export default {
  name: '',
  components: {},
  model: {
    prop: 'data',
    event: 'onDataChange'
  },
  props: {
    data: {
      type: [String, Number],
      default: () => ''
    },
    hasAll: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    // 主机厂id
    oemId: {
      type: [String, Number],
      default: () => ''
    },
    // 是否必须主机厂id有值，才加载数据，用于解决新增编辑反选数据不关联的问题
    isData: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: [String],
      default: () => ''
    }
  },
  data() {
    return {
      remoteLoading: false,
      selected: '',
      modelList: []
    };
  },
  computed: {},
  watch: {
    data: {
      immediate: true,
      handler(data) {
        this.selected = data;
      }
    },
    selected: {
      handler(selected) {
        this.$emit('onDataChange', selected);
      }
    },
    oemId: {
      handler(oemId, l_oemId) {
        if (oemId && l_oemId) {
          // 主机厂id更改时，清除已选
          this.selected = '';
        }
        if (oemId) {
          this.getModelList('default');
        }
      }
    }
  },
  mounted() {},
  methods: {
    async getModelList(query) {
      if (!query) return;
      this.remoteLoading = true;
      const params = {
        pageIndex: 1,
        pageSize: 1000,
        oemId: this.oemId,
        iccid: query !== 'default' ? query : ''
      };
      const { data } = await getUnBoundIccid(params);
      this.modelList = data.list?.map((item) => {
        return {
          value: item.iccid,
          label: item.iccid
        };
      });
      this.remoteLoading = false;
    }
  }
};
</script>
<style scoped lang="scss">
</style>
